'use client';

import { useMemo, useState } from 'react';
import { cafe24SsurroundV2 } from '../fonts';
import LockIcon2120 from '@svg/allthattravel/lock_icon_21_20.svg';
import HintZ102102 from '@svg/allthattravel/hint_z_102_102.svg';
import HintI102102 from '@svg/allthattravel/hint_i_102_102.svg';
import HintM102102 from '@svg/allthattravel/hint_m_102_102.svg';
import './allthattravel-hint-modal.css';
import usePreventBodyScroll from '@/app/hooks/usePreventBodyScroll';

export default function AllThatTravelHintModal({ step }: { step: 1 | 2 | 3 | 4 }) {
  const [isOpen, setIsOpen] = useState(true);

  const contents = useMemo(() => {
    if (step === 1) {
      return {
        title: (
          <h2 className={`${cafe24SsurroundV2.className} text-center text-new-gray-900 text-24pxr font-bold`}>
            <span className='text-new-point-500'>언제</span> 떠나시나요?
          </h2>
        ),
        subTitle: (
          <p className='text-center text-new-gray-900 whitespace-pre-line body-16-regular'>
            여행 떠나실 날짜를 선택해 주세요!{'\n'}
            <span className='text-new-gray-800 body-14-regular '>최대 5박6일 선택가능해요 :)</span>
          </p>
        ),
        content: (
          <div className='flex flex-col gap-8pxr items-center'>
            <div className='flex flex-col gap-4pxr items-center'>
              <LockIcon2120 />
              <span className='text-new-gray-900 text-16pxr leading-24pxr font-medium'>첫번째 탈출코드</span>
            </div>
            <HintZ102102 />
          </div>
        ),
      };
    } else if (step === 2) {
      return {
        title: (
          <h2 className={`${cafe24SsurroundV2.className} text-center text-new-gray-900 text-24pxr font-bold`}>
            <span className='text-new-point-500'>누구와 함께</span> 가시나요?
          </h2>
        ),
        subTitle: (
          <p className='text-center text-new-gray-900 whitespace-pre-line body-16-regular'>
            누구와 함께 가시는지 알려주세요!
          </p>
        ),
        content: (
          <div className='flex flex-col gap-8pxr items-center'>
            <div className='flex flex-col gap-4pxr items-center'>
              <LockIcon2120 />
              <span className='text-new-gray-900 text-16pxr leading-24pxr font-medium'>두번째 탈출코드</span>
            </div>
            <HintZ102102 />
          </div>
        ),
      };
    } else if (step === 3) {
      return {
        title: (
          <h2 className={`${cafe24SsurroundV2.className} text-center text-new-gray-900 text-24pxr font-bold`}>
            <span className='text-new-point-500'>어디로</span> 떠나시나요?
          </h2>
        ),
        subTitle: (
          <p className='text-center text-new-gray-900 whitespace-pre-line body-16-regular'>
            여행지를 검색하여 선택할 수 있어요!{'\n'}
            <span className='text-new-gray-800 body-14-regular '>(앞에서 선택한 도시로 미리 채워두었어요!)</span>
          </p>
        ),
        content: (
          <div className='flex flex-col gap-8pxr items-center'>
            <div className='flex flex-col gap-4pxr items-center'>
              <LockIcon2120 />
              <span className='text-new-gray-900 text-16pxr leading-24pxr font-medium'>세번째 탈출코드</span>
            </div>
            <HintI102102 />
          </div>
        ),
      };
    } else {
      return {
        title: (
          <h2 className={`${cafe24SsurroundV2.className} text-center text-new-gray-900 text-24pxr font-bold`}>
            <span className='text-new-point-500'>일정표를 공유</span>해보세요!
          </h2>
        ),
        subTitle: (
          <p className='text-center text-new-gray-900 whitespace-pre-line body-16-regular'>
            일정표 완성! 지금까지 모은 단서들을{'\n'}
            <span className='body-16-md'>일정표 공유</span>하기 버튼을 눌러 입력해보세요!
          </p>
        ),
        content: (
          <div className='flex flex-col gap-8pxr items-center'>
            <div className='flex flex-col gap-4pxr items-center'>
              <LockIcon2120 />
              <span className='text-new-gray-900 text-16pxr leading-24pxr font-medium'>마지막 탈출코드</span>
            </div>
            <HintM102102 />
          </div>
        ),
      };
    }
  }, [step]);

  usePreventBodyScroll(isOpen);

  if (!isOpen) return null;
  return (
    <div className='fixed w-full max-w-480pxr top-0 h-dvh bg-black/40 overflow-hidden flex px-20pxr items-center z-20'>
      <div id='allthattravel-hint-modal-container'>
        <div
          id='allthattravel-hint-modal'
          className={`w-full bg-white rounded-16pxr py-40pxr px-20pxr flex flex-col gap-30pxr items-center
      transition-transform duration-500 ease-out
        `}
        >
          <div className='w-full flex flex-col gap-16pxr items-center'>
            <div id='allthattravel-hint-modal-title' className='flex flex-col gap-8pxr'>
              {contents.title}
              {contents.subTitle}
            </div>
            <div id='allthattravel-hint-modal-content'>{contents.content}</div>
          </div>
          <button
            id='allthattravel-hint-modal-button'
            className='w-full h-50pxr rounded-8pxr bg-new-point-100 body-16-md text-new-point-500'
            onClick={() => setIsOpen(false)}
          >
            진행하기
          </button>
        </div>
      </div>
    </div>
  );
}
